export default {
  red: '#fc0202',
  blue: '#003cff',
  green: '#29810e',
  yellow: '#f3db04',
};
